
import React from 'react';
import { Check, Users, Link as LinkIcon, Globe, Shield, Gift, Zap } from 'lucide-react';

interface PlanFeatureIconProps {
  featureName: string;
}

const PlanFeatureIcon: React.FC<PlanFeatureIconProps> = ({ featureName }) => {
  const name = featureName.toLowerCase();
  
  if (name.includes('refer')) return <Gift className="h-4 w-4 text-primary mr-2 shrink-0" />;
  if (name.includes('manager')) return <Users className="h-4 w-4 text-primary mr-2 shrink-0" />;
  if (name.includes('link')) return <LinkIcon className="h-4 w-4 text-primary mr-2 shrink-0" />;
  if (name.includes('domain')) return <Globe className="h-4 w-4 text-primary mr-2 shrink-0" />;
  if (name.includes('white')) return <Shield className="h-4 w-4 text-primary mr-2 shrink-0" />;
  if (name.includes('integration')) return <Zap className="h-4 w-4 text-primary mr-2 shrink-0" />;
  
  return <Check className="h-4 w-4 mr-2 shrink-0" />;
};

export default PlanFeatureIcon;
